/**
 * Full-screen loading overlay shown while a session snapshot is being restored.
 */

import React from "react";
import { getUIColorPalette } from "../../theme/ColorPalette";
import ItinerarySearchLoader from "../ItinerariesPlanner/itineraryList/ItinerarySearchLoader";

/** Props for {@link SessionRestoreLoadingOverlay}. */
export interface SessionRestoreLoadingOverlayProps {

    /** Whether the dark UI palette is active. */
    "isDarkUi": boolean;
}

/**
 * Non-dismissible overlay that blocks interaction while the session is restored.
 *
 * @param props - Component props.
 * @returns The overlay element, or `null` if not visible.
 */
export const SessionRestoreLoadingOverlay: React.FC<SessionRestoreLoadingOverlayProps> = ( { isDarkUi } ) => {
    const palette = getUIColorPalette( isDarkUi );

    return (
        <div
            aria-live="polite"
            className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
            onClick={( event ) => {
                event.preventDefault();
            }}
            role="status"
            style={{
                "backgroundColor": palette.modalBackdropBackground,
                "pointerEvents":   "all",
            }}
        >
            <ItinerarySearchLoader />
            <p
                className="mt-4 text-center text-base font-medium"
                style={{ "color": palette.overlayTextPrimary }}
            >
                Chargement...
            </p>
        </div>
    );
};
